export class SwaggerResponseContentOptionsSchema {
  public $ref: string;
}
